import { render, staticRenderFns } from "./FailedUploadsModal.vue?vue&type=template&id=6265010d&scoped=true&"
import script from "./FailedUploadsModal.vue?vue&type=script&lang=js&"
export * from "./FailedUploadsModal.vue?vue&type=script&lang=js&"
import style0 from "./FailedUploadsModal.vue?vue&type=style&index=0&id=6265010d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6265010d",
  null
  
)

export default component.exports